import {Injectable} from '@angular/core';


@Injectable()
export class ListingEffects {


  constructor() {
  }

}

